import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

export default function Home() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-foreground mb-4">
        欢迎使用必竟宜居应用平台
      </h1>
      <p className="text-muted-foreground">
        请从左侧导航栏选择功能模块开始使用。
      </p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card>
          <CardHeader>
            <CardTitle>数据对接</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              管理外部数据库连接、构建表型录、配置字段映射、同步数据。
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
